import { CommonModule } from '@angular/common';
import { DateFormatPipe } from './pipes/date-format.pipe';
import { DxcBadgeModule } from '@dxc/ui-components/badge';
import { DxcButtonModule } from '@dxc/ui-components/button';
import { DxcIconModule } from '@dxc/ui-components/icon';
import { DxcInputModule } from '@dxc/ui-components/input';
import { DxcLoaderModule } from '@dxc/ui-components/loader';
import { DxcTypographyModule } from '@dxc/ui-components/typography';
import { FixedSectionLoaderComponent } from './components/fixed-section-loader/fixed-section-loader.component';
import { FormsModule } from '@angular/forms';
import { IntervalToDurationPipe } from './pipes/interval-to-duration.pipe';
import { NgModule } from '@angular/core';
import { SectionLoaderComponent } from './components/section-loader/section-loader.component';
import { StatusIconComponent } from './components/status-icon/status-icon.component';
import { TableEmptyStateComponent } from './components/table-empty-state/table-empty-state.component';

@NgModule({
  declarations: [
    TableEmptyStateComponent,
    IntervalToDurationPipe,
    DateFormatPipe,
    StatusIconComponent,
    SectionLoaderComponent,
    FixedSectionLoaderComponent
  ],
  imports: [
    CommonModule,
    DxcTypographyModule,
    DxcInputModule,
    DxcButtonModule,
    DxcIconModule,
    DxcLoaderModule,
    DxcBadgeModule
  ],
  exports: [
    // angular
    FormsModule,

    // components
    TableEmptyStateComponent,
    StatusIconComponent,
    SectionLoaderComponent,
    FixedSectionLoaderComponent,

    //pipes
    IntervalToDurationPipe,
    DateFormatPipe,

    // modules
    DxcTypographyModule,
    DxcInputModule,
    DxcButtonModule,
    DxcIconModule,
    DxcLoaderModule
  ]
})
export class SharedModule {}
